__turbopack_context__.v({
  "alert": "_4PTToW_alert",
  "boldText": "_4PTToW_boldText",
  "frequencySelect": "_4PTToW_frequencySelect",
  "header": "_4PTToW_header",
  "modal": "_4PTToW_modal",
  "modalContent": "_4PTToW_modalContent",
  "modalFooter": "_4PTToW_modalFooter",
  "topBar": "_4PTToW_topBar",
});
